import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyDidntWork } from './components/WhyDidntWork';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream text-teal selection:bg-gold/30 selection:text-teal font-sans" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <WhyDidntWork data-id="element-4" />
      <Mechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <ForWhom data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <Offer data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}